import { SEARCH, SET_USER_FOUND } from "./constants"

export function searchAction(q) {
    return{
        type: SEARCH,
        q,
    }
}
export function setUserFound(data) {
    return{
        type: SET_USER_FOUND,
        data
    }
}